import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { decodeJwtPayload } from '../../utils/jwt';
import { alcanca } from '../../shared/papeis';

interface RoleGuardProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

/**
 * Autorização de tela.
 *
 * at-81 (ADR 0044): decide por INTERSEÇÃO — quem acumula funções entra em todas as telas dos
 * seus papéis. O ADMIN mantém o bypass, em qualquer posição da lista.
 *
 * ⚠️ A prop `requireAdmin` foi removida: existia desde sempre e nenhuma rota do `App.tsx` a
 * usava. Tela só de ADMIN se declara com `requiredRoles={['ADMIN']}`, como o Dashboard Oficina
 * já fazia.
 *
 * ⚠️ O formato SINTÁTICO de `requiredRoles` no `App.tsx` é lido por um parser textual do backend
 * (`papeis-da-tela.spec.ts`, ADR 0028). Mudar a forma como as listas são escritas lá quebra o CI
 * do outro repo — a leitura aqui pode evoluir à vontade, a escrita lá não.
 */
const RoleGuard: React.FC<RoleGuardProps> = ({ children, requiredRoles = [] }) => {
  const accessToken = useSelector((state: RootState) => state.auth.accessToken);
  const payload = decodeJwtPayload<{ userType?: string; papeis?: string[] }>(accessToken);

  return alcanca(payload, requiredRoles) ? <>{children}</> : <Navigate to="/home" />;
};

export default RoleGuard;
